import { Modal, List, Typography, Card, Button } from 'antd';
import VirtualList from 'rc-virtual-list';
import { messageReadAll, messageRead } from '@/utils/api/common';
import { asyncNoticeInit } from "@/app/reducers/noticeReducer";
import useCustomStoreHooks from '@/hooks/useStore';
import './index.less';

export default function Index(props) {
  const { list = [], open, dispatch, toggleNoticeOpen, navigate } = props;
  const { translate } = useCustomStoreHooks();
  const $t = (key) => translate({ translate_language_key: 'component.notice.language', key });
  const readAll = async () => {
    if (list.length) {
      const { data: { code } } = await messageReadAll();
      if (+code === 0) {
        dispatch(asyncNoticeInit());
      }
    }
  };

  const viewNotice = async (item) => {
    if (!item.is_read) {
      const { data: { code } } = await messageRead({ id: item.id });
      if (+code === 0) {
        dispatch(asyncNoticeInit());
      }
    }

    const noticeTypeOptions = {
      'join_user': () => {
        //账号关联-详情
        navigate(`/notice/company_relevance?id=${item.params.id}`);
      },
      'tender_bidder': () => {
        //投标方-列表
        navigate(`/supplier/bid/list`);
        window.sessionStorage.setItem('tender_no', item.params.tender_no);
      },
      'tender_ree': () => {
        //招标方-列表
        navigate(`/buyers/tender/list`);
        window.sessionStorage.setItem('tender_no', item.params.tender_no);
      },
    };
    noticeTypeOptions[item.type]?.();
    toggleNoticeOpen();
  };

  return (
    <Modal open={open} footer={null} width={800} title={$t('Message center')} onCancel={toggleNoticeOpen} getContainer={false}>
      <Card title={$t('Message')} extra={<Typography.Link type='danger' onClick={readAll}>{$t('All set to read')}</Typography.Link>}>
        <List>
          <VirtualList data={list} height={400} itemHeight={47} itemKey="id">
            {(item) => (
              <List.Item key={item.id} className='notice-item'>
                <List.Item.Meta
                  title={<div className='flex-space-between'><div>{<span className={[!item.is_read ? 'circle' : 'circle_empty']}></span>}{item.title}</div><span style={{ fontSize: '14px', color: '#999', fontWeight: 'initial' }}>{item.create_time}</span></div>}
                  description={<div className='flex-space-between'><div style={{ paddingLeft: 20 }}>{item.content}</div><Button type='link' danger onClick={() => viewNotice(item)}>{$t('View')}</Button></div>} >
                </List.Item.Meta>
              </List.Item>
            )}
          </VirtualList>
        </List>
      </Card>
    </Modal>
  );
}
